const categoryType = {
  SPONSOR: 0,
  AGENDA: 1,
  SPEAKER: 2,
  SPONSOR_CATEGRORY: 3
};

export { categoryType };
